import { useTranslation } from "react-i18next"
import React from 'react'
import './TutorAssignmentButton.scss'
import { useDispatch } from 'react-redux'
import { openModal } from '../tutorAssignmentSlice/tutorAssignmentSlice'
import { getUserData } from "Services/API";
import { useSelector } from "react-redux";

export default function TutorAssignmentButton() {
  const dispatch = useDispatch()
  const {t} = useTranslation('tutor_assignment_modal')
  const roster = useSelector(state => state.reports.roster)

 const isButtonDisabled = (roster) => {
  const isRosterEmpty = Object.keys(roster).length === 0;
  const isRosterPending = roster.status && roster.status.type !== "COMPLETE";
  return isRosterEmpty || isRosterPending;
};

  const handleOpenModal = () => {
    dispatch(openModal())
  }

  const { tutorAssignmentEnabled } = getUserData()
  if (!tutorAssignmentEnabled) return null;

  return (
    <div className='tutor-assignment-button-container'>
        <button className='tutor-assignment-button' onClick={handleOpenModal} disabled={isButtonDisabled(roster)}>{t('add_assignment')}</button>
    </div>
    )
}

